export default "__VITE_ASSET__f8a879d8__"